<app-base-modal
  [open]="isOpen()"
  (openChange)="onOpenChange($event)"
  [title]="dialogTitle()"
  [size]="'md'"
>
  @if (currentPaper(); as p) {
    <div class="flex flex-col gap-3" data-testid="attach-pdf-dialog">
      <p class="truncate text-xs text-gray-500" [attr.title]="p.title">{{ p.title }}</p>

      <input
        #fileInput
        type="file"
        accept="application/pdf"
        class="hidden"
        (change)="onPick($event)"
        data-testid="attach-pdf-file-input"
      />

      <div
        class="flex flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed p-6 text-center transition-colors"
        [class.border-secondary]="dragOver()"
        [class.bg-slate-50]="dragOver()"
        [class.border-slate-300]="!dragOver()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        data-testid="attach-pdf-drop-zone"
      >
        <p class="text-sm text-gray-700">Drag a PDF here</p>
        <p class="text-xs text-gray-500">or</p>
        <button
          type="button"
          class="btn-small-secondary"
          (click)="fileInput.click()"
          data-testid="attach-pdf-pick-button"
        >
          Choose PDF
        </button>
        <p class="text-xs text-gray-400">Max 100 MB</p>
      </div>

      @if (fileError(); as msg) {
        <p class="text-sm text-red-700" data-testid="attach-pdf-file-error">{{ msg }}</p>
      }

      @if (file(); as f) {
        <div
          class="flex items-center justify-between rounded-md bg-slate-50 p-2 text-sm"
          data-testid="attach-pdf-selected-file"
        >
          <span class="truncate" [attr.title]="f.name"
            >{{ f.name }} — {{ formatSize(f.size) }}</span
          >
          <button
            type="button"
            class="ml-2 text-red-600 hover:text-red-700"
            (click)="clearFile()"
            aria-label="Remove file"
            data-testid="attach-pdf-remove-file"
          >
            ×
          </button>
        </div>
      }

      @if (submitError(); as msg) {
        <app-base-alert
          type="error"
          title="Could not attach PDF"
          [message]="msg"
          [closeable]="false"
          data-testid="attach-pdf-error"
        ></app-base-alert>
      }

      <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          (click)="close()"
          class="btn-small-secondary"
          data-testid="attach-pdf-cancel"
        >
          Cancel
        </button>
        <button
          type="button"
          (click)="submit()"
          class="btn-primary"
          [disabled]="!file() || submitting()"
          data-testid="attach-pdf-submit"
        >
          {{ submitting() ? 'Uploading…' : currentPaper()?.hasPdf ? 'Replace' : 'Attach' }}
        </button>
      </div>
    </div>
  }
</app-base-modal>
